// extracted by mini-css-extract-plugin
export default {"cls1":"NavigationDrawerFlyoutMenu-FlyoutIndicator_cls1__F-hzz","cls2":"NavigationDrawerFlyoutMenu-FlyoutIndicator_cls2__7P8Ac NavigationDrawerFlyoutMenu-FlyoutIndicator_cls1__F-hzz"};